import { 
  SET_FILTRO_REBATES,
  LOADING_REBATES, 
  FETCH_REBATES, 
  FETCH_REBATE, 
  EDIT_REBATE
} from './types';
import { fetchListRebatesApi, fetchRebatesApi } from "../api/axios";


export const setFiltroRebates = (filtro) => dispatch => {
  
  dispatch({
    type: SET_FILTRO_REBATES,
    payload: filtro
  });

}

export const fetchRebates = (params) => async dispatch => {

  dispatch({
    type: LOADING_REBATES,
    payload: true
  });
  
  const req = fetchListRebatesApi(params);

  req.then((response) => {

    dispatch({
      type: FETCH_REBATES,
      payload: response
    });

    dispatch({
      type: LOADING_REBATES,
      payload: false
    });
  })
}

export const fetchRebate = (params) => async dispatch => {
  dispatch({
    type: LOADING_REBATES,
    payload: true
  });

  const req = fetchRebatesApi(params);

  req.then((rebate) => {

    dispatch({
      type: FETCH_REBATE,
      payload: rebate
    });

    dispatch({
      type: LOADING_REBATES,
      payload: false
    });
  })
}

export const editRebate = (rebate) => dispatch => {
  
  dispatch({
    type: EDIT_REBATE,
    payload: rebate
  });
}